import styled from "styled-components";

const CandidateProfileWrapper = styled.div`
  background: #e4e5e7;
`;

export { CandidateProfileWrapper as default };
